function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\n\t\ticon-navigation\n\t");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "\n\t\tCreated with Sketch.\n\t");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "icon-navigation",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M154.973262,9.95096602 C153.386474,6.32488073 149.926991,4 146.118069,4 C142.309148,4 138.849665,6.32488073 137.262876,9.95096602 L58.7468319,203.883189 C57.1856226,207.81528 58.1212924,212.349245 61.0936911,215.25534 C64.0660897,218.161434 68.4496746,218.828069 72.088656,216.927403 L141.631438,180.329419 C144.384816,178.904217 147.615184,178.904217 150.368562,180.329419 L219.911344,216.927403 C223.550325,218.828069 227.93391,218.161434 230.906309,215.25534 C233.878708,212.349245 234.814377,207.81528 233.253168,203.883189 L154.973262,9.95096602 Z",
  id: "Path",
  fill: "currentColor",
  fillRule: "nonzero",
  transform: "translate(146.000000, 111.000000) rotate(-330.000000) translate(-146.000000, -111.000000) "
}));

var SvgIconNavigation = function SvgIconNavigation(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconNavigation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-navigation.197d2663.svg";
export { ForwardRef as ReactComponent };